export default {
  cart: [],
  previewSurvey: {},
  surveys: [],
  filteredSurveys: [],
  // @templateHashes contains all the hashes from the surveys the user owns. These are not the hashes from the surveys availlable in the store!
  // @templateHashes is used to check which surveys the user owns. If we know which surveys the user owns we know which surveys the user can rate.
  templateHashes: [],
  cronbachScore: 0
}
